"use client";
import Link from "next/link";
import { useLocale } from "next-intl";
import { useAuth } from "@/components/providers/auth-provider";
import { Button } from "@/components/ui/button";
import { signInHref } from "@/lib/post-login-redirect";

export function ContestTempNav() {
  const { user, logout } = useAuth();
  const locale = useLocale();
  const bn = locale === "bn";
  if (!user?.tempContest) return null;
  return <nav aria-label={bn ? "প্রতিযোগিতার মেনু" : "Contest navigation"} className="flex shrink-0 flex-wrap items-center gap-2 border-b border-[rgb(var(--border))] bg-white px-4 py-2 text-sm">
    <Link className="inline-flex min-h-11 items-center px-3 font-[family-name:var(--font-ubuntu)]" href={`/${locale}/contests/${user.tempContest.slug}`}>{bn ? "আমার প্রতিযোগিতা" : "My contest"}</Link>
    {user.tempContest.warmUp ? <Link className="inline-flex min-h-11 items-center px-3" href={`/${locale}/contests/${user.tempContest.warmUp.slug}`} data-testid="temp-nav-warm-up">Warm-up</Link> : null}
    <Link className="inline-flex min-h-11 items-center px-3" href={`/${locale}/playground`}>Playground</Link>
    <Link className="inline-flex min-h-11 items-center px-3" href={`/${locale}/dashboard/profile`}>{bn ? "প্রোফাইল" : "Profile"}</Link>
    <Button variant="tertiary" className="ml-auto min-h-11" onClick={async () => { await logout(); window.location.assign(signInHref(locale)); }}>{bn ? "লগ আউট" : "Sign out"}</Button>
  </nav>;
}
